import axios from "axios";
import getIdeasApiURL from "@src/services/ideas/getIdeasApiURL";

async function unfollowChannel(channelName) {
  const path = `/api/ideas/follow/${channelName}`;
  const r = await axios.delete(`${getIdeasApiURL()}${path}`);

  return r;
}

export default unfollowChannel;
